<template>
  <v-dialog width="500px"
            :value="value"
            @input="closeModal"
            :persistent="!readonly"
            scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbGold" dark text flat>
        <div class="text-h6">
          {{
            (methodNewViewEdit === 'edit' && $t('general.edit')) ||
            (methodNewViewEdit === 'new' && $t('general.new')) ||
            (methodNewViewEdit === 'view' && $t('general.view'))
          }}
          Dj
        </div>
        <v-spacer/>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text ref="content">
        <v-form v-model="validForm" ref="form" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="newViewEditDjObj.name"
                @keyup.enter="submit"
                :readonly="readonly"
                :label="$t('general.name')"
                :rules="[rules.required]"
                color="kbDarkBlue"
                autofocus
              />
            </v-col>

            <v-col cols="12" v-if="!appUserWasAlreadyCreated">
              <CountryPhonePicker :value="countryPhonePicker" @input="setCountryPhone"/>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="newViewEditDjObj.email"
                @keyup.enter="submit"
                :readonly="appUserWasAlreadyCreated"
                :label="$t('general.email')"
                :rules="[rules.required]"
                color="kbDarkBlue"
              />
            </v-col>
            <v-col cols="12" v-if="!appUserWasAlreadyCreated">
              <v-text-field
                v-model="newViewEditDjObj.password"
                @keyup.enter="submit"
                :label="$t('general.password')"
                type="password"
                :rules="[rules.required, rules.min8]"
                color="kbDarkBlue"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="newViewEditDjObj.status"
                @keyup.enter="submit"
                :readonly="readonly"
                :label="$t('general.status')"
                color="kbDarkBlue"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="newViewEditDjObj.followers"
                @keyup.enter="submit"
                :readonly="readonly"
                :label="$t('general.followers')"
                color="kbDarkBlue"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="newViewEditDjObj.location"
                @keyup.enter="submit"
                :readonly="readonly"
                :label="$t('general.location')"
                color="kbDarkBlue"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="newViewEditDjObj.locationUrl"
                @keyup.enter="submit"
                :readonly="readonly"
                :label="$t('general.locationUrl')"
                color="kbDarkBlue"
              />
            </v-col>
            <v-col cols="12" md="4" v-if="readonly">
              <v-card>
                <v-img
                  :src="newViewEditDjObj.profilePhotoUrl"
                  style="border-radius: 5px; max-height: 134px"
                  alt="Dj photo" class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                />
                <!-- <v-card-actions>
                  <v-spacer></v-spacer>

                </v-card-actions> -->
              </v-card>
            </v-col>
            <HtmlEditor v-model="newViewEditDjObj.rawHtml"/>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn class="mr-2"
               color="red"
               outlined
               @click="closeModal">
          {{methodNewViewEdit === 'view' ? $t('general.close') : $t('general.cancel')}}
        </v-btn>

        <v-btn @click="submit"
               color="kbGold"
               dark
               :loading="loading"
               v-if="methodNewViewEdit !== 'view'">
          {{ $t('general.saveChanges') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import CountryPhonePicker from '@/components/ui/CountryPhonePicker'
import HtmlEditor from '@/components/ui/HtmlEditor'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  components: { CountryPhonePicker, HtmlEditor },
  computed: {
    ...mapState({
      methodNewViewEdit: state => state.events.methodNewViewEditDj
    }),
    newViewEditDjObj: {
      get () {
        return this.$store.state.events.newViewEditDjObj
      },
      set (value) {
        this.$store.commit('SET_NEW_VIEW_EDIT_DJ_OBJ', value)
      }
    },
    readonly () {
      return this.methodNewViewEdit === 'view'
    },
    appUserWasAlreadyCreated () {
      return !!(this.newViewEditDjObj &&
          this.newViewEditDjObj.userId)
    }
  },
  data () {
    return {
      validForm: false,
      countryPhonePicker: {
        country: 'Colombia',
        code: 'co',
        number: '57',
        phone: ''
      },
      rules
    }
  },
  mounted () {
  },
  methods: {
    async submit () {
      try {
        if (await !this.$refs.form.validate()) return notifications.error(this.$t('general.completeRequiredFields'))
        if (this.methodNewViewEdit === 'new') {
          const response = await this.$store.dispatch('createDj')
          if (response) {
            notifications.success(this.$t('general.djSuccessfullyCreated'))
            this.closeModal()
          }
        }
        if (this.methodNewViewEdit === 'edit') {
          const response = await this.$store.dispatch('updateDj')
          if (response) {
            notifications.success(this.$t('general.djSuccessfullyUpdated'))
            this.closeModal()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    setCountryPhone (data) {
      this.countryPhonePicker = data

      this.newViewEditDjObj.phone = data.phone
      this.newViewEditDjObj.country = data.code
      this.newViewEditDjObj.countryCode = data.number
    },
    closeModal () {
      // this.$refs.form.reset()
      this.newEditProductObj = {}
      this.$emit('input', false)
    }
  },
  watch: {
    value (value) {
      if (value) {
        if (this.methodNewViewEdit === 'new' || this.methodNewViewEdit === 'edit') {
          if (this.$refs.content) this.$refs.content.scrollTop = 0
        }
      }
    }
  },
  props: ['value', 'loading']
}
</script>
<style scoped>
</style>
